/**
 * useDebounce Hook
 * Delays updating a value until after a specified delay has passed
 * Useful for search inputs to avoid excessive API calls
 */

import { useEffect, useState } from "react"
import { API } from "@/constants/constants"

export function useDebounce<T>(value: T, delay: number = API.DEBOUNCE_DELAY_MS): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value)

  useEffect(() => {
    // Set up timeout to update debounced value after delay
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    // Cleanup timeout if value changes before delay expires
    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])

  return debouncedValue
}
